export function roleIdToString(roleId) {

    switch (roleId) {
        case 2:
            return 'Мендежер системы'
        case 3:
            return 'Организация'
        case 4:
            return 'Медицинский центр'
        case 5:
            return 'Удостоверяющий центр'
        case 7:
            return 'Пациент'
        case 8:
            return 'Кабинетный лаборант'
        case 9:
            return 'Машинный лаборант'
    }

}